import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.span`
  margin-left: 0.5rem;
`;

export { Container, Label };
